import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { InfrastructureDto } from '../../../core/dto/infrastructure';
import { IsavValidators } from '../../../utils/forms/validators';
import { ChangesService } from '../../../core/changes-warning/changes.service';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'isav-infrastructure-form',
    templateUrl: './infrastructures-form.html',
    styleUrls: ['./infrastructures-form.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfrastructuresForm implements OnChanges, OnInit, OnDestroy {
    @Input() value: Partial<InfrastructureDto>;
    @Output() save = new EventEmitter<Partial<InfrastructureDto>>();
    @Output() remove = new EventEmitter<void>();
    @Output() publish = new EventEmitter<InfrastructureDto>();
    @Output() unpublish = new EventEmitter<void>();
    isExportedFromSios: boolean;

    form = new UntypedFormGroup({
        name: new UntypedFormControl(null, [
            IsavValidators.required('Infrastructure name is required!'),
        ]),
        description: new UntypedFormControl(null, [
            IsavValidators.required('Infrastructure description is required!'),
        ]),
        contactName: new UntypedFormControl(null, [
            IsavValidators.required('Contact name is required!'),
        ]),
        contactEmail: new UntypedFormControl(null, [
            IsavValidators.required('Contact email is required!'),
        ]),
        contactPhone: new UntypedFormControl(null),
        organisation: new UntypedFormControl(null, [
            IsavValidators.required('Organisation is required!'),
        ]),
        organizationLink: new UntypedFormControl(null),
        externalLink: new UntypedFormControl(null),
        types: new UntypedFormControl(null, [IsavValidators.required('Type is required!')]),
        address: new UntypedFormControl(null),
        areaCode: new UntypedFormControl(null),
        city: new UntypedFormControl(null),
        country: new UntypedFormControl(null, [IsavValidators.required('Country is required!')]),
        region: new UntypedFormControl(null, [IsavValidators.required('Region is required!')]),
        image: new UntypedFormControl(null),
        coordinates: new UntypedFormControl(null, [IsavValidators.coordinates()]),
        sarAsset: new UntypedFormControl(null),
        attachments: new UntypedFormControl(null),
        dontOverrideTypesWhenExporting: new UntypedFormControl(false),
    });

    constructor(private readonly changesService: ChangesService) {}

    ngOnInit() {
        this.changesService.connect(this.form);
        this.isExportedFromSios = this.value?.exportedFromSIOS || false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value && this.value) {
            this.form.reset(this.value);
        }
    }

    ngOnDestroy() {
        this.changesService.disconnect(this.form);
    }

    onSave() {
        this.form.reset(this.form.value);
        this.save.emit({
            ...this.form.value,
        });
    }

    onDelete() {
        this.form.reset(this.form.value);
        this.remove.emit();
    }

    onPublish() {
        this.form.reset(this.form.value);
        this.publish.emit({
            ...this.form.value,
        });
    }

    onUnpublish() {
        this.form.reset(this.form.value);
        this.unpublish.emit();
    }
}
